import React, { useMemo } from "react";
import { OPEN_HOLLAEX_DOC_APP_CREATION } from "../../config/media";

export const HeaderFooterLinks = ({ linkText, path, className }) => {

	const url = `https://docs.hollaex.com/plugins/${path}`

	const onHandleClick = (linkText) => {
		switch (linkText) {
			case 'PLUGIN BLOG POST':
				return 'https://www.hollaex.com/blog/plugin-apps-and-the-hollaex-exchange-app-store'
			case 'RUN DEV MODE':
				return 'https://docs.hollaex.com/developers/run-dev-mode'
			default:
				return url;
		}
	}

	return (
		<div className={className === 'header' ? 'docs-link' : ''} onClick={() => window.open(onHandleClick(linkText), '_blank')}>
			<span className="link-text cursor-pointer">{linkText}</span>
			<img
				src={OPEN_HOLLAEX_DOC_APP_CREATION}
				alt="open-hollaex-doc-app-creation-link"
				className={className === 'header' ? 'docs-link-header' : 'docs-link-footer'}
			/>
		</div>
	)
}

export const RenderPlugin = ({ id, heading, content, renderList, pluginCategory, imgSrc }) => {

	const renderUrl = (id) => {
		const urlMap = {
			refferalsAndRewards: 'https://docs.hollaex.com/plugins/develop-plugins',
			onOffRamping: 'https://www.hollaex.com/blog/banxa-teams-up-with-hollaex-for-seamless-crypto-payment-integration',
		};
		const url = urlMap[id] || 'https://docs.hollaex.com/plugins/installing-plugin';
		window.open(url, '_blank');
	};

	const isPlugin = useMemo(() => {
		return renderList(pluginCategory).some(ele => !!ele)
	}, [pluginCategory, renderList])

	return (
		<div id={id} className={'plugin-wrapper'}>
			<h1 className='bold app-title'>{heading}</h1>
			{id === 'onOffRamping' ? <p className="d-flex">Pre-integrated payment provides for off and on ramping of fiat currency requires <p className="ml-1 text-decoration-underline">Fiat Ramp or DIY Boost</p></p> : <p>{content}</p>}
			{isPlugin ? <div className="plugin-list-wrapper">{renderList(pluginCategory)}</div> : <p>Can't find any plugin apps by that search term.</p>}
			{imgSrc ? <img alt='plugins' onClick={() => renderUrl(`${id}`)} className='plugin-img cursor-pointer' src={imgSrc}></img> : ''}
		</div>
	)
}